const configuredApiBase = (process.env.REACT_APP_API_BASE_URL || '/api').trim().replace(/\/$/, '');
const runningOnHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';

// Guard against mixed-content in hosted HTTPS environments.
const normalizedApiBase = runningOnHttps && configuredApiBase.startsWith('http://')
	? '/api'
	: configuredApiBase;

export const API_BASE_URL = normalizedApiBase;
export const API_ASSET_BASE_URL = (process.env.REACT_APP_ASSET_BASE_URL || normalizedApiBase).trim().replace(/\/$/, '');
